import { HeaderDocuments } from "../../utils/headerTable/TabHeaderDocuments";
import AgencyAction from "../action/AgencyAction";
import TableComponentPaginationClient from "../main/TablePaginationClient";

export default function DocumentsList({ listDocuments, idAzienda, listCategories }: any) {

    return (

        <>
            <div className="flex items-center justify-end">
                <AgencyAction type="addDocument" label="Aggiungi documento" idAzienda={idAzienda} listCategories={listCategories} />
            </div>

            {listDocuments.length > 0
                ? <TableComponentPaginationClient
                    columns={HeaderDocuments(listCategories)}
                    data={listDocuments}
                    type="userList"
                    isDisabledPagination={false}
                />
                : <p className="p-6 text-center">NESSUNA DOCUMENTO PRESENTE</p>
            }
        </>
    )
}